import axios from 'axios';
import {FinancialYearAPIsConstants} from "../enums/FinancialYearEnums";

const FinancialYearModule = {
  namespaced: true,
  state: {
    data: [],
  },
  mutations: {
    SET_DATA(state, payload) {
      state.data = payload.map((row) => {
        let arr = [];
        row.translations.map((lang) => {
          arr[lang.locale] = lang;
          row[lang.locale] = lang;
        });
        row['translations'] = arr;
        return row;
      });
    },
  },
  actions: {
    getData({ commit }) {
      axios
        .get(`${FinancialYearAPIsConstants.API_PATH}`)
        .then((res) => {
          commit('SET_DATA', res.data.result.financial_years);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  getters: {

  },
};
export default FinancialYearModule;
